import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

export const PRODUCT_ID_PROVIDER = new InjectionToken<IProductIdProvider>('PRODUCT_ID_PROVIDER');

export interface IProductIdProvider {
    productId$: Observable<number>;
}